import React from 'react';

const UserInput = ({ type, placeholder, value, onChange }) => (
  <input
    type={type}
    placeholder={placeholder}
    className="input-box"
    value={value}
    onChange={onChange}
  />
);

export default UserInput;